// Identifier helpers for API paths/payloads. An ID that is missing, 0, negative, NaN or
// non-numeric must never be sent to the backend as if it were a real record ID.

// Returns the ID as a positive integer, or null when it is not a usable ID.
export const toPositiveId = (value) => {
	if (value === null || value === undefined || value === "") return null;
	const id = Number(value);
	return Number.isInteger(id) && id > 0 ? id : null;
};

// Returns the ID as an integer >= 0, or null. Only for fields whose backend contract
// legitimately uses 0 (e.g. subCourseId = 0 for a normal, non-subcourse course).
export const toNonNegativeId = (value) => {
	if (value === null || value === undefined || value === "") return null;
	const id = Number(value);
	return Number.isInteger(id) && id >= 0 ? id : null;
};
